import { useApolloClient } from '@apollo/react-hooks';
import useAccountCustomer from '../useAccountCustomer';
import { OneTimePayConfigData } from '../../components/payment-form/oneTimePayment.types';
import { getFormattedToday } from '../../util/format';
import { FormState } from '../useFormState.types';
import useFormState from '../useFormState';
import paymentInfoFormRules, {
  Model as PaymentInfoModel,
} from '../../components/payment-form/payment-info-form/PaymentInfoForm.rules';
import { useServiceProviderInfo } from './useInvoicePaymentAccountInfo';
import { useSavedProfileList } from './usePaymentus';

export default ({ skipAccountInfo = false } = {}) => {
  const { personId, encryptedPersonId } = useServiceProviderInfo();
  const apolloClient = useApolloClient();
  const {
    loading: profileListLoading,
    savedProfileList,
    refetch: refetchProfileList,
  } = useSavedProfileList(personId!);

  const refetchProfileListDetails = () => refetchProfileList();

  
  return {
    encryptedPersonId,
    savedProfileList,
    profileListLoading,
    refetchProfileListDetails,  
  };
};

export function defaultPaymentInfoFormData(
  data: OneTimePayConfigData,
): PaymentInfoModel {
  return {
    paymentAmount: data.paymentAmount || '',
    paymentDate: data.paymentDate || getFormattedToday(),
  };
}

export function usePaymentInfoFormState(
  data: OneTimePayConfigData,
): FormState<PaymentInfoModel> {
  return useFormState(defaultPaymentInfoFormData(data), {
    validate: paymentInfoFormRules,
    validationContext: {
      maxPayDate: data.maxPaymentDate,
      fullAmount: data.fullAmount,
      selectedReconnectOption: data.selectedReconnectOption,
      minimumAmount: data.minimumAmount,
      maximumAmount: data.maximumAmount,
      charitySelection: data.charitySelection,
    },
  });
}
